import { useHistory } from 'react-router-dom';
import { Hidden, List, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import PlusIcon from 'common/icons/plus-icon';

const useStyles = makeStyles(() => ({
  taskContainer: {
    marginTop: '12px',
    width: '100%',
    background: '#FFFFFF',
    justifyContent: 'center',
    boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.25)',
    borderRadius: '2px',
  },
  listContainer: {
    overflow: 'auto',
  },
  listItem: {
    width: '95%',
    margin: 'auto',
    background: '#F1FCFF',
    boxSizing: 'border-box',
    boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.25)',
    borderRadius: '2px',
    marginBottom: '20px',
    marginTop: '20px',
    padding: '15px',
  },
  listTagContainer: {
    alignSelf: 'center',
  },

  taskTitle: { display: 'flex', zIndex: -0.5 },

  title: {
    fontWeight: 600,
  },
  userIcon: {
    color: '#096094',
    position: 'relative',
  },
}));

export default function ConciergeActions() {
  const classes = useStyles();
  const history = useHistory();

  return (
    <>
      <Typography className={classes.title} variant="h5">
        Actions
      </Typography>
      <div className={classes.taskContainer}>
        <List className={classes.listContainer}>
          <ListItem button className={classes.listItem} disableRipple>
            <ListItemIcon>
              <PlusIcon fill="#096094" />
            </ListItemIcon>
            <Hidden mdDown={true}>
              <ListItemText primary="Create a task for all of my clients" />
            </Hidden>
            <Hidden mdUp={true}>
              <ListItemText primary="Create a new task" />
            </Hidden>
          </ListItem>
          <ListItem
            button
            className={classes.listItem}
            disableRipple
            onClick={() => history.push(`/home/referrals`)}
          >
            <ListItemIcon>
              <img src="/person-box-icon.svg" alt="person-box" />
            </ListItemIcon>
            <ListItemText primary="Manage corporate referrals" />
          </ListItem>
        </List>
      </div>
    </>
  );
}
